import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  transactionSources: [],
  exampleFileImportDataUrl: '',
}

export const mutations = {
  SET_TRANSACTION_SOURCES(state, transactionSources) {
    state.transactionSources = transactionSources
  },
  SET_EXAMPLE_FILE_IMPORT_DATA_URL(state, url) {
    state.exampleFileImportDataUrl = url
  },
}

export const actions = {
  downloadFileExcel(_, payload) {
    return ApiService.downloadFileExcel(payload)
      .then((res) => {
        const results = res.data
        return results
      })
      .catch((error) => {
        throw error
      })
  },
  generateLogsFileExcel(_, payload) {
    return ApiService.generateLogsFileExcel(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  generateLogsFilePdf(_, payload) {
    return ApiService.generateLogsFilePdf(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  generateFileExcel(_, payload) {
    return ApiService.generateFileExcel(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  generateFilePdf(_, payload) {
    return ApiService.generateFilePdf(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  jobProcess(_, payload) {
    return ApiService.jobProcess(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  generateFileProgress(_, job_process_uuid) {
    return ApiService.generateFileProgress(job_process_uuid)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  fetchTransactionSources({ commit }) {
    return ApiService.fetchTransactionSources()
      .then((res) => {
        const transactionSources = res.data.data
        commit('SET_TRANSACTION_SOURCES', transactionSources)
      })
      .catch((error) => {
        throw error
      })
  },
  downloadTransaction(_, payload) {
    return ApiService.downloadTransaction(payload)
      .then(({ data }) => {
        return data
      })
      .catch((error) => {
        throw error
      })
  },
  downloadTransactionNfc(_, payload) {
    return ApiService.downloadTransactionNfc(payload)
      .then(({ data }) => {
        return data
      })
      .catch((error) => {
        throw error
      })
  },
  downloadExampleFileImportData({ commit }, payload) {
    return ApiService.downloadExampleFileImportData(payload)
      .then((res) => {
        const { url } = res.data
        commit('SET_EXAMPLE_FILE_IMPORT_DATA_URL', url)
        return url
      })
      .catch((error) => {
        throw error
      })
  },
  generateFileProgress(_, job_process_uuid) {
    return ApiService.generateFileProgress(job_process_uuid)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
}
